import { render, staticRenderFns } from "./BaseQuick.vue?vue&type=template&id=dd08851e&scoped=true&"
import script from "./BaseQuick.vue?vue&type=script&lang=js&"
export * from "./BaseQuick.vue?vue&type=script&lang=js&"
import style0 from "./BaseQuick.vue?vue&type=style&index=0&id=dd08851e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd08851e",
  null
  
)

export default component.exports